import React from "react";

const BarIcon = () => {
  return (
    <svg
      fill="#667085"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M6,11a1,1,0,0,1,1,1v7a1,1,0,0,1-2,0V12A1,1,0,0,1,6,11Zm5-6V19a1,1,0,0,0,2,0V5a1,1,0,0,0-2,0Zm6,3.5V19a1,1,0,0,0,2,0V8.5a1,1,0,0,0-2,0Z"></path>
      </g>
    </svg>
  );
};

export default BarIcon;
